
/* eslint-disable */
import Mixins from '@/shared'
import firebase from 'firebase/compat/app'
import { functions } from '@/firebase/functions'
import { Match } from '@/interfaces/match'
import { Group } from '@/interfaces/group'
import { Competition } from '@/interfaces/competition'
import GroupTeamManagement from '@/components/GroupTeamManagement.component.vue'
import { showSnackbar } from '@/globalActions'

// Edit match details
export default {
  name: 'EditMatch',
  mixins: [Mixins],
  components: {
    GroupTeamManagement
  },
  props: {
    // Match details
    matchData: {
      type: Object,
      default: () => ({ empty: true }),
      required: true
    },
    competition: {
      type: Object as () => Competition,
      required: true
    }
  },
  data: () => ({
    visible: false,
    snackbar: {
      visible: false,
      text: '' as any
    },
    spiideo: {
      dialog: false,
      loadingScenes: false,
      loadingRecipes: false,
      syncing: false,
      deleting: false,
      pushingPhase: false,
      sceneId: null as string | null,
      recipeId: null as string | null,
      scenes: [] as Array<{ id: string; name: string }>,
      recipes: [] as Array<{ id: string; name: string }>
    },
    match: {} as Match,
    group: {} as Group,
    dateMenu: false,
    inputDate: null as any,
    date: null as any,
    officials: [{
      name: '',
      role: 'referee1'
    }, {
      name: '',
      role: 'referee2'
    }, {
      name: '',
      role: 'secretary'
    }, {
      name: '',
      role: 'timeKeeper'
    }, {
      name: '',
      role: 'delegate'
    }]
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    matchStates () {
      const match_states = firebase.remoteConfig().getString('match_states')
      const states = match_states.split(',')
      return states
    },
    spiideoMatchPhases () {
      return [
        { text: this.$t('spiideo-phase-pre_match'), value: 'pre_match' },
        { text: this.$t('spiideo-phase-ordinary'), value: 'ordinary' },
        { text: this.$t('spiideo-phase-intermission'), value: 'intermission' },
        { text: this.$t('spiideo-phase-overtime'), value: 'overtime' },
        { text: this.$t('spiideo-phase-penalty-shootout'), value: 'penalty-shootout' },
        { text: this.$t('spiideo-phase-post_match'), value: 'post_match' }
      ]
    }
  },
  created () {
    this.visible = true
    if (!this.matchData.empty) {
      this.match = this.matchData
      this.setDate()
    }
    this.group = this.$store.getters['GroupModule/filterTeamsByGroup'](this.match.groupId)[0]
  },
  mounted () {
    document.addEventListener("keydown", (e) => {
        if (e.code === 'Escape') {
          this.$emit('close');
        }
    });
  },
  methods: {
    setDate () {
      if (!this.match.date) {
        return new Date()
      }
      const t = new Date(1970, 0, 1)
      t.setSeconds((this.match.date as any).seconds)
      this.date = t.toISOString().substr(0, 10)
      this.inputDate = this.formatDate(t.toISOString().substr(0, 10))
    },
    setState (state: string) {
      const missing = Object.values(this.match).find(e => e === 'MISSING')
      if (missing) return 'error'
      return (state === 'INCOMPLETE_IMPORT') ? 'error' : 'success'
    },
    async save () {
      if (!('officials' in this.match)) {
        this.match.officials = this.officials
      }
      if (!('competitionName' in this.match)) {
        this.match.competitionName = this.competition.name
      }
      this.match.date = firebase.firestore.Timestamp.fromDate(new Date(this.date + ' ' + this.match.time))

      const intermissionMinutes = Number(this.match.intermissionDurationMinutes)
      if (!Number.isFinite(intermissionMinutes) || intermissionMinutes <= 0) {
        delete this.match.intermissionDurationMinutes
      } else {
        this.match.intermissionDurationMinutes = Math.floor(intermissionMinutes)
      }

      // Resolve club shortName for both teams
      const homeTeam = this.match.homeTeam || {}
      const awayTeam = this.match.awayTeam || {}
      const clubTeamsData = (this.$store.state.ClubTeamsModule && this.$store.state.ClubTeamsModule.data) || {}

      let homeClubId = homeTeam.clubId || (clubTeamsData[homeTeam.teamId] && clubTeamsData[homeTeam.teamId].clubId)
      let awayClubId = awayTeam.clubId || (clubTeamsData[awayTeam.teamId] && clubTeamsData[awayTeam.teamId].clubId)

      // Fetch teams to get clubId if missing
      if (!homeClubId && homeTeam.teamId) {
        await this.$store.dispatch('ClubTeamsModule/fetchById', homeTeam.teamId)
        const teamData = this.$store.state.ClubTeamsModule && this.$store.state.ClubTeamsModule.data && this.$store.state.ClubTeamsModule.data[homeTeam.teamId]
        homeClubId = teamData && teamData.clubId
        if (homeClubId) this.match.homeTeam = { ...this.match.homeTeam, clubId: homeClubId }
      }
      if (!awayClubId && awayTeam.teamId) {
        await this.$store.dispatch('ClubTeamsModule/fetchById', awayTeam.teamId)
        const teamData = this.$store.state.ClubTeamsModule && this.$store.state.ClubTeamsModule.data && this.$store.state.ClubTeamsModule.data[awayTeam.teamId]
        awayClubId = teamData && teamData.clubId
        if (awayClubId) this.match.awayTeam = { ...this.match.awayTeam, clubId: awayClubId }
      }

      const clubFetchPromises = []
      if (homeClubId && !(this.$store.state.ClubsModule && this.$store.state.ClubsModule.data && this.$store.state.ClubsModule.data[homeClubId])) {
        clubFetchPromises.push(this.$store.dispatch('ClubsModule/fetchById', homeClubId))
      }
      if (awayClubId && awayClubId !== homeClubId && !(this.$store.state.ClubsModule && this.$store.state.ClubsModule.data && this.$store.state.ClubsModule.data[awayClubId])) {
        clubFetchPromises.push(this.$store.dispatch('ClubsModule/fetchById', awayClubId))
      }
      await Promise.all(clubFetchPromises)

      const clubsDataAfter = (this.$store.state.ClubsModule && this.$store.state.ClubsModule.data) || {}
      if (homeClubId && clubsDataAfter[homeClubId]) {
        this.match.homeTeam = { ...this.match.homeTeam, shortName: clubsDataAfter[homeClubId].shortName }
      }
      if (awayClubId && clubsDataAfter[awayClubId]) {
        this.match.awayTeam = { ...this.match.awayTeam, shortName: clubsDataAfter[awayClubId].shortName }
      }

      this.match.homeTeam = this.filterObj(this.match.homeTeam, ['name', 'shortName', 'teamId', 'clubId', 'players', 'bench'])
      this.match.awayTeam = this.filterObj(this.match.awayTeam, ['name', 'shortName', 'teamId', 'clubId', 'players', 'bench'])

      this.$store.dispatch('MatchModule/patch', this.match).then(() => {
        this.snackbar.visible = true
        this.snackbar.text = this.$t('match-updated')
        this.close()
      }).catch((error: any) => {
        showSnackbar(error, { duration: 5000 })
      })
    },
    async pushSpiideoMatchPhase () {
      if (!this.match.id || !this.match.matchPhase) {
        showSnackbar(this.$t('spiideo-phase-required') as string, { duration: 5000 })
        return
      }
      this.spiideo.pushingPhase = true
      try {
        const payload: Record<string, unknown> = {
          id: this.match.id,
          matchPhase: this.match.matchPhase
        }
        const intermissionMinutes = Number(this.match.intermissionDurationMinutes)
        if (Number.isFinite(intermissionMinutes) && intermissionMinutes > 0) {
          payload.intermissionDurationMinutes = Math.floor(intermissionMinutes)
        }
        await this.$store.dispatch('MatchModule/patch', payload)
        showSnackbar(this.$t('spiideo-phase-pushed') as string)
      } catch (err: any) {
        showSnackbar(
          (err && err.message) || (this.$t('spiideo-sync-failed') as string),
          { duration: 5000 }
        )
      } finally {
        this.spiideo.pushingPhase = false
      }
    },
    async openSpiideoSync () {
      if (!this.competition.spiideoEnabled) {
        showSnackbar(this.$t('spiideo-enabled-required') as string, { duration: 5000 })
        return
      }
      this.spiideo.dialog = true
      this.spiideo.sceneId = this.match.spiideoSceneId || null
      this.spiideo.recipeId = this.match.spiideoRecipeId || null
      const loads: Promise<void>[] = []
      if (this.spiideo.scenes.length === 0) {
        loads.push(this.loadSpiideoScenes())
      }
      if (this.spiideo.recipes.length === 0) {
        loads.push(this.loadSpiideoRecipes())
      }
      if (loads.length > 0) {
        await Promise.all(loads)
      }
    },
    async loadSpiideoScenes () {
      this.spiideo.loadingScenes = true
      try {
        const listScenes = functions.httpsCallable('spiideoListScenesV2')
        const result: any = await listScenes({})
        this.spiideo.scenes = (result && result.data && result.data.scenes) || []
      } catch (err: any) {
        console.error('spiideoListScenesV2', err)
        showSnackbar(
          (err && err.message) || (this.$t('spiideo-sync-failed') as string),
          { duration: 5000 }
        )
        this.spiideo.dialog = false
      } finally {
        this.spiideo.loadingScenes = false
      }
    },
    async loadSpiideoRecipes () {
      this.spiideo.loadingRecipes = true
      try {
        const listRecipes = functions.httpsCallable('spiideoListRecipesV2')
        const result: any = await listRecipes({})
        this.spiideo.recipes = (result && result.data && result.data.recipes) || []
      } catch (err: any) {
        console.error('spiideoListRecipesV2', err)
        showSnackbar(
          (err && err.message) || (this.$t('spiideo-sync-failed') as string),
          { duration: 5000 }
        )
        this.spiideo.dialog = false
      } finally {
        this.spiideo.loadingRecipes = false
      }
    },
    async syncMatchToSpiideo () {
      if (!this.spiideo.sceneId || !this.match.id) {
        showSnackbar(this.$t('spiideo-scene-required') as string, { duration: 5000 })
        return
      }
      if (!this.spiideo.recipeId) {
        showSnackbar(this.$t('spiideo-recipe-required') as string, { duration: 5000 })
        return
      }
      this.spiideo.syncing = true
      try {
        const syncMatch = functions.httpsCallable('spiideoSyncMatchV2')
        const result: any = await syncMatch({
          matchId: this.match.id,
          sceneId: this.spiideo.sceneId,
          recipeId: this.spiideo.recipeId
        })
        const data = (result && result.data) || {}
        const patch: Record<string, unknown> = {
          id: this.match.id,
          spiideoEventId: data.spiideoEventId || null,
          spiideoGameId: data.spiideoGameId || null,
          spiideoSceneId: data.spiideoSceneId || null,
          spiideoRecipeId: data.spiideoRecipeId || null,
          spiideoProductionId: data.spiideoProductionId || null,
          spiideoOutputId: data.spiideoOutputId || null
        }
        if (data.spiideoDataSetId) {
          patch.spiideoDataSetId = data.spiideoDataSetId
        }
        if (data.spiideoHomeContenderId) {
          patch.spiideoHomeContenderId = data.spiideoHomeContenderId
        }
        if (data.spiideoAwayContenderId) {
          patch.spiideoAwayContenderId = data.spiideoAwayContenderId
        }
        // Patch via store so Vue 2 reactivity + the group table checkmark update
        // (new fields are not reactive when assigned with plain =).
        await this.$store.dispatch('MatchModule/patch', patch)
        Object.keys(patch).forEach((key) => {
          if (key === 'id') return
          this.$set(this.match, key, patch[key])
        })
        this.spiideo.dialog = false
        showSnackbar(this.$t(
          data.updated ? 'spiideo-match-resync-success' : 'spiideo-match-sync-success'
        ) as string)
      } catch (err: any) {
        console.error('spiideoSyncMatchV2', err)
        const message = (err && err.message) || ''
        const competitionNotSynced =
          /Competition must be synced to Spiideo/i.test(message) ||
          /enrolled in the Spiideo competition/i.test(message)
        const spiideoNotEnabled =
          /Spiideo is not enabled for this competition/i.test(message)
        showSnackbar(
          spiideoNotEnabled
            ? (this.$t('spiideo-enabled-required') as string)
            : competitionNotSynced
              ? (this.$t('spiideo-match-competition-required') as string)
              : (message || (this.$t('spiideo-sync-failed') as string)),
          { duration: 6000 }
        )
      } finally {
        this.spiideo.syncing = false
      }
    },
    confirmDeleteFromSpiideo () {
      if (!this.match.id || !(this.match.spiideoGameId || this.match.spiideoEventId)) {
        return
      }
      const ok = window.confirm(this.$t('spiideo-delete-match-confirm') as string)
      if (ok) {
        this.deleteMatchFromSpiideo()
      }
    },
    async deleteMatchFromSpiideo () {
      if (!this.match.id) {
        return
      }
      if (!this.competition.spiideoEnabled) {
        showSnackbar(this.$t('spiideo-enabled-required') as string, { duration: 5000 })
        return
      }
      this.spiideo.deleting = true
      try {
        const deleteMatch = functions.httpsCallable('spiideoDeleteMatchV2')
        await deleteMatch({ matchId: this.match.id })
        const clearFields = [
          'spiideoEventId',
          'spiideoGameId',
          'spiideoSceneId',
          'spiideoRecipeId',
          'spiideoProductionId',
          'spiideoOutputId',
          'spiideoDataSetId',
          'spiideoHomeContenderId',
          'spiideoAwayContenderId'
        ]
        clearFields.forEach((key) => {
          this.$delete(this.match, key)
        })
        showSnackbar(this.$t('spiideo-delete-match-success') as string, {
          color: 'success'
        })
      } catch (err: unknown) {
        console.error('spiideoDeleteMatchV2', err)
        const message = err instanceof Error ? err.message : String(err || '')
        const spiideoNotEnabled =
          /Spiideo is not enabled for this competition/i.test(message)
        showSnackbar(
          spiideoNotEnabled
            ? (this.$t('spiideo-enabled-required') as string)
            : (message || (this.$t('spiideo-sync-failed') as string)),
          { duration: 6000 }
        )
      } finally {
        this.spiideo.deleting = false
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
